const BASE_EDIT_FORM = {
  versionType: '',
  remark: '',
  file: ''
}
export { BASE_EDIT_FORM }
